import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 礼物图鉴展览馆 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92458611
export const getGiftBooks = createAsyncThunk(
  'HiyaGiftBook/infoV2',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/account/info_v2', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 礼物图鉴说明页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105302077
export const suitDetail = createAsyncThunk(
  'HiyaGiftBook/suitDetail',
  async (p: any = {}, store: any) => {
    const resp = await http.post(
      'live/gift/suit_detail',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export interface InitialStateType {
  sub_detail: {
    offset: number
    more: boolean
    suit: any
    rank_list: Array<any>
  }
  name?: string
  suit_list: Array<any>
  gift_suit_info?: {
    total?: number
    activate_count?: number
  }
}

const initialState: InitialStateType = {
  // 具体的信息
  sub_detail: {
    offset: 0,
    more: false,
    suit: null,
    rank_list: [],
  },
  // 展览馆
  suit_list: [],
  name: '',
}
export const GiftBookSlice = createSlice({
  name: 'GiftBook',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getGiftBooks.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(suitDetail.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state.sub_detail, data)
    })
  },
})

export default GiftBookSlice.reducer
